import TextField from './TextField';

const TextArea = ({ minRows = 5, maxRows = 10, ...props }) => {
  return <TextField multiline rows={minRows} {...props} />;
};

export default TextArea;
